import { render, staticRenderFns } from "./TaskTopMain.vue?vue&type=template&id=8b9b33a4"
import script from "./TaskTopMain.vue?vue&type=script&lang=js"
export * from "./TaskTopMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports